import { HttpErrorResponse } from '@angular/common/http';
import { createSelector } from 'reselect';
import { Action } from '@ngrx/store';
import { AppState } from '../../app.state';

import * as appointmentsActions from './appointments.actions';
import { Appointment } from '../../shared/models/appointment.model';

export interface State {
  readonly entities: Appointment[];
}

const initialState: State = {
  entities: [],
};

export function appointmentsReducer(state = initialState, action: Action): State {
  switch (action.type) {
    case appointmentsActions.actionTypes.SET_APPOINTMENTS:
      return {
        entities: [
          ...state.entities,
          ...action.payload,
        ],
      };

    case appointmentsActions.actionTypes.RESET_APPOINTMENTS:
      return {
        entities: [],
      };

    default:
      return state;
  }
}

export const getAppointmentsState = (state: AppState) => state.appointments;
export const getAppointments = createSelector(getAppointmentsState, (state: State): Appointment[] => state.entities);



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/appointments/appointments.reducer.ts